import {Fragment} from "react";

import {Button, Col, Container, Nav, Row} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import NewUser from "./NewUser";
import NewCategory from "./NewCategory";
import TableSetting from "./TableSetting";
import AssignOfficer from "./AssignOfficer";


export default function Employee(){

    return(
        <Fragment>
            <div className="purchaseDiv text-center">
                <Nav className="navItem float-end"><NavLink to="/home"><Button variant="warning" >Close</Button></NavLink></Nav>
                <h3>Employee management</h3>
                <hr/>
                <Tabs
                    defaultActiveKey="home"
                    transition={false}
                    id="noanim-tab-example"
                    className="mb-3"
                >
                    <Tab eventKey="home" title="Home"></Tab>

                    <Tab eventKey="User" title="User Creation"><NewUser/></Tab>
                    <Tab eventKey="category" title="Category"><NewCategory/></Tab>
                    <Tab eventKey="setting" title="Setting"><TableSetting/></Tab>
                    <Tab eventKey="officer" title="Officer Assign"><AssignOfficer/></Tab>

                </Tabs>
            </div>
        </Fragment>
    )
}
